import { render, staticRenderFns } from "./FormBuilderForm.vue?vue&type=template&id=47c20966&"
import script from "./FormBuilderForm.vue?vue&type=script&lang=js&"
export * from "./FormBuilderForm.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports